import React from "react";
import "./WaitingFor.css";
import { FormattedMessage } from "react-intl";

export default function WaitingFor() {
  return (
    <section className="waitingFor">
      <div className="header">
        {/* <h2>What are you waiting for?</h2> */}
        <h2 className="header__title">
          <FormattedMessage id={"footer_banner_title"} />
        </h2>
        <p>
          <FormattedMessage id={"footer_banner_subtitle"} />
        </p>
      </div>
      <div className="contents">
        <img src="https://wpreact.goopter.com/wp-content/uploads/2021/10/pc-image.png" />
        <div className="text-wrapper">
          <p>
            <FormattedMessage id={"footer_banner_desc"} />
          </p>
        </div>

        <a className="accent-button" href="/request-a-demo">
          <FormattedMessage id={"request_a_free_demo"} />
        </a>
      </div>
    </section>
  );
}
